import * as React from 'react';

function SvgListStars(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path
				fillRule='evenodd'
				d='M5 11.5a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0-4a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z'
			/>
			<path d='M2.242 2.194a.27.27 0 01.516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 00-.094.3l.173.569c.078.256-.213.462-.423.3l-.417-.324a.267.267 0 00-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 00-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 00.259-.194l.162-.53zm0 4a.27.27 0 01.516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 00-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 00-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 00-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 00.259-.194l.162-.53zm0 4a.27.27 0 01.516 0l.162.53c.035.115.14.194.258.194h.551c.259 0 .37.333.164.493l-.468.363a.277.277 0 00-.094.3l.173.569c.078.255-.213.462-.423.3l-.417-.324a.267.267 0 00-.328 0l-.417.323c-.21.163-.5-.043-.423-.299l.173-.57a.277.277 0 00-.094-.299l-.468-.363c-.206-.16-.095-.493.164-.493h.55a.271.271 0 00.259-.194l.162-.53z' />
		</svg>
	);
}

export default SvgListStars;
